import { Checkbox, Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ControlService from "./LabelControlService";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import DefaultChip from "../../componentes/chip/DefaultChip";
import GridButtonRow from "../../componentes/form-grids/GridButtonRow";
import DefaultButton from "../../componentes/button/DefaultButton";

export const LabelConsult = () => {

    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        idProduct: 0,
        productCode: "",
        productName: "",
        idStorage: 0,
        idStreet: 0,
        idColumn: 0,
        idLevel: 0,
        rows: [],
        userId: userId,
        cdStatus: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    const { t } = useTranslation();
    const { control } = useForm();
    const { id, idProduct, productCode, productName, idStorage, idStreet, idColumn, idLevel, cdStatus } = state
    const { success, error, rows, ...data } = state

    const handleCheck = (id, checked) => {
        const updatedRows = state.rows.map(row =>
            row.id === id ? { ...row, cancelPrint: checked } : row
        );

        dispatch({ type: "update", data: { rows: updatedRows } });
    };

    const handleCodeProduct = () => {
        
        ControlService
            .getByCodeProduct(data)
            .then((response) => {
                
                if (response.data) {
                
                    dispatch({
                        type: 'update',
                        data: {
                            idProduct: response.data.idProduct,
                            barCode: response.data.barCode,
                            productName: response.data.productName,
                        }
                    });
                }
            })
            .catch((e) => {
            });
    };

    const handleProductName = () => {
        let request = { ...state }

        ControlService
            .getByProductName(request)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: 'update',
                        data: {
                            idProduct: response.data.idProduct,
                            productCode: response.data.productCode,
                            barCode: response.data.barCode,
                        }
                    });
                }
            })
            .catch(() => {});
    };

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } }) 
    }

    const handleClear = () => {
        dispatch({ type: 'clear' });
    }

    const handleCancel = () => {
        const selected = state.rows.filter(row => row.cancelPrint);

        if (selected.length === 0) {
            dispatch({ type: "clear" });
            return;
        }

        // gera string "1,2,3"
        const ids = selected.map(r => r.id).join(",");

        const request = { idsSelecteds: ids };

        ControlService
            .cancelPrint(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: "success" });
                    handleSearch(); // recarrega a grid depois do cancelamento
                }
            })
            .catch(() => dispatch({ type: "error" }));
    };

    const handleSearch = () => {

        let request = { ...state };

        if (request.id) {
            request.id = parseInt(request.id, 10);
        } else {
            request.id = 0; // ou delete request.id;
        }

        ControlService
            .filterPrint(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } });
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    useEffect(() => {
        if (state.productCode) {
            handleCodeProduct();
        }
    }, [state.productCode]);

    useEffect(() => {
        if (state.productName) {
            handleProductName();
        }
    }, [state.productName]);

    const columns = (t) => [
        {
            field: "cancelPrint",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} name="cancelPrint" />;
            },
            template: (rowData) => (
            <Checkbox
                checked={rowData.cancelPrint || false}
                onChange={(e) => handleCheck(rowData.id, e.target.checked)}
                color="primary"
            />
            ),
        },
        {
            field: "id",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="cod" />;
            },
            template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.id}
                        </Typography>}
                    />
                </>
            )
        }
        },
        {
            field: "productCode",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="code" />;
            },
        },
        {
            field: "description",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="description" />;
            },
            template: (props) => {
            return (
                <>
                    {props.description ?
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.description}
                            </Typography>}
                        />
                    : null}
                </>
            )
        }
        },
        {
            field: "quantity",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="quantity" />;
            },
            template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.quantity}
                        </Typography>}
                    />
                </>
            )
        }
        },
        {
            field: "statusPrint",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusPrint" />;
            },
            template: (props) => {
                let chipStyle;
                let statusDesc

                switch (props.statusPrint) {
                    case 1:
                        chipStyle = "grey";
                        statusDesc = "Enviado para Impressão";
                        break;
                    case 2:
                        chipStyle = "progress";
                        statusDesc = "Impressão em Andamento";
                        break;
                    case 3:
                        chipStyle = "finished";
                        statusDesc = "Finalizado";
                        break;
                    default:
                        chipStyle = "grey";
                        break;
                }

                return (
                    <>
                    
                        <DefaultChip
                            style={chipStyle}
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{statusDesc}
                            </Typography>}
                        />
                    </>
                )
            }
            
        }
    ];

    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="code" labelName="productCode" />
                                }
                                name="productCode"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={productCode}
                                labelName={"productCode"}
                                inputProps={{ maxLength: 30 }}
                                error={error && productCode === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="product" labelName="productName" />
                                } 
                                name="productName"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={productName}
                                inputProps={{ maxLength: 100 }}
                                error={error && productName === ""}
                            />
                        </Grid>
                    </GridInputRow>
                    <GridInputRow>
                        <Grid item xs={12} sm={4} md={4}>
                            <DefaultAutocomplete
                                name={"idStorage"}
                                onChange={handleChange}
                                placeholder={t("storage")}
                                label={t("storage")}
                                useApi
                                endpoint='GetStorageAutoComplete'
                                value={idStorage}
                                defaultSize
                                error={error && idStorage === 0}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={3}>
                            <DefaultAutocomplete
                                name={"idStreet"}
                                onChange={handleChange}
                                placeholder={t("street")}
                                label={t("street")}
                                useApi
                                endpoint='GetStreetAutoComplete'
                                value={idStreet}
                                defaultSize
                                error={error && idStreet === 0}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={3}>
                            <DefaultAutocomplete
                                name={"idColumn"}
                                onChange={handleChange}
                                placeholder={t("column")}
                                label={t("column")}
                                useApi
                                endpoint='GetColumnAutoComplete'
                                value={idColumn}
                                defaultSize
                                error={error && idColumn === 0}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2}>
                            <DefaultAutocomplete
                                name={"idLevel"}
                                onChange={handleChange}
                                placeholder={t("level")}
                                label={t("level")}
                                useApi
                                endpoint='GetLevelAutoComplete'
                                value={idLevel}
                                defaultSize
                                error={error && idLevel === 0}
                            />
                        </Grid>
                    </GridInputRow>

                    <GridButtonRow>
                        <Grid item xs={4} sm={3} md={2}>
                            <DefaultButton clear className="secondaryButton" onClick={handleClear} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={2}>
                            <DefaultButton search className="primaryButton" onClick={handleSearch} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={3}>
                            <DefaultButton labelName={t("cancelPrint")} className="primaryButton" onClick={handleCancel} />
                        </Grid>
                    </GridButtonRow>


                    {(rows.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    dataSource={rows}
                                    allowPaging={true}
                                />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}